export default "__VITE_ASSET__0WXnHT0O__"